// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "-legacy." + {"92":"cea7aba9","240":"14ad2630","276":"1790df80","321":"9278ff14","410":"7749ec80","509":"720bdc8a","594":"8806363b","782":"6cd45845","801":"b5d81a57","838":"52b658a8","898":"882b6847","902":"e4d59a2e"}[chunkId] + ".js";
};